import { useConfig } from "@kikoda/generated-config-hooks";

export interface AppConfig {
    additionalConfig: {
        hppUrl: string,
        backendUrl: string,
        siteKey: string
    }
};

const useAppConfig = () => useConfig<AppConfig>();

export default useAppConfig;